import EdSummary  from "./EdSummary";

export default EdSummary;